import React from "react";
import styles from "./sec.module.css";
import { Col, Container, Row } from "react-bootstrap";

const ImageSection = () => {
  return (
    <React.Fragment>
      <Container>
        <Row>
          <Col>
            <div className={styles.main_section}>
              <h6>Partner with Excellence</h6>
              <p>
                Discover the difference of working with a trusted global leader
                in trade and innovation.
              </p>

              <div className={styles.ImageMainSection}>
                <div className={styles.imageContainer}>
                  <img
                    loading="lazy"
                    src="/images/landingPageImages/Slide 2.png"
                    alt="Sample"
                    className={styles.image}
                  />
                  <div className={styles.title}>
                    <h6>One-Stop Solution</h6>
                    <p>From Sourcing to delivery, we handle every step of the process with precision</p>
                  </div>
                </div>
                <div className={styles.imageContainer}>
                  <img
                    loading="lazy"
                    src="/images/landingPageImages/Slide 4.png"
                    alt="Sample"
                    className={styles.image}
                  />
                     <div className={styles.title}>
                    <h6>One-Stop Solution</h6>
                    <p>From Sourcing to delivery, we handle every step of the process with precision</p>
                  </div>
                </div>
                <div className={styles.imageContainer}>
                  <img
                    loading="lazy"
                    src="/images/landingPageImages/Slide 5.png"
                    alt="Sample"
                    className={styles.image}
                  />
                     <div className={styles.title}>
                    <h6>One-Stop Solution</h6>
                    <p>From Sourcing to delivery, we handle every step of the process with precision</p>
                  </div>
                </div>
                <div className={styles.imageContainer}>
                  <img
                    loading="lazy"
                    src="/images/landingPageImages/piggybank.png"
                    alt="Sample"
                    className={styles.image}
                  />
                     <div className={styles.title}>
                    <h6>One-Stop Solution</h6>
                    <p>From Sourcing to delivery, we handle every step of the process with precision</p>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default ImageSection;
